import { AlertOctagon } from 'lucide-react';
import Ayuda from '../ui/Ayuda';
import { fechaLarga } from './suscripcion';

/* =====================================================================
   El cartel de un módulo cerrado por falta de pago · Peaje U-04
   =====================================================================
   Es el mismo hecho que el 403 de la puerta con `motivo: "pago"`
   (`peaje/estado.cartel_de_mora`), dicho ANTES de que alguien pulse
   Guardar: qué pasó (está en consulta), por qué (el pago está pendiente
   desde una fecha) y qué hacer (pagar en Ajustes → Suscripción). Rojo,
   porque es un problema; sin precio, porque el plan ya lo trae.
   Lo monta `escala/CartelDeModulo.jsx` cuando la escalera dice CONSULTA.
   ===================================================================== */
export default function CartelDeMora({ nombre, desde, onIr }) {
  const fecha = fechaLarga(desde);
  return (
    <div role="status" data-motivo="pago"
         className="mx-4 mt-3 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-900 md:mx-6">
      <div className="flex items-start gap-3">
        <AlertOctagon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
        <div className="min-w-0 flex-1 space-y-1">
          <p>
            <strong>{nombre}</strong> está <strong>en consulta por falta de pago</strong>
            {fecha ? ` desde el ${fecha}` : ''}: se ve todo lo que ya existe, pero no se registra nada nuevo. Nada se borró.
          </p>
          <p>Al pagar desde Ajustes → Suscripción se vuelve a abrir.</p>
          <Ayuda id="peaje.mora.cartel" />
        </div>
      </div>
      {onIr && (
        <div className="mt-2 pl-7">
          <button type="button" onClick={() => onIr('suscripcion')}
                  className="min-h-11 w-full rounded-lg bg-[var(--color-marca)] px-3 py-1.5 font-semibold text-white sm:w-auto">
            Ir a pagar
          </button>
        </div>
      )}
    </div>
  );
}
